import { TerminalSettingsService } from "congress/shared/layout/terminal/terminal-settings.service";
import {
    Component,
    ElementRef,
    Injector,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { EventInformationsModalComponent } from "@app/event/event-informations-modal/event-informations-modal.component";
import {
    CartHelperService,
    IRegistrationCart,
} from "@app/store/cart/cart-helper-service";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/common/app-component-base";
import {
    CreateOrEditRegistrationByAdminDto,
    CreateOrEditRegistrationOutput,
    CreditCardPaymentDto,
    EntityDtoOfInt64,
    EventCategoryDeadlineDto,
    EventsServiceProxy,
    EventToSignUpDto,
    EventTypesServiceProxy,
    MemberCategoryEditDto,
    NoteDto,
    OrdersServiceProxy,
    PaymentChargesServiceProxy,
    PaymentDto,
    RegistrationEventDto,
    RegistrationsServiceProxy,
    RegistrationUserEditDto,
    RegistrationUserMemberEditDto,
    TerminalSettingDto,
    UpdatePaymentInput,
} from "@shared/service-proxies/service-proxies";
import * as _ from "lodash";
import { AppUserAddressDtoType, PaymentMethod } from "@shared/AppEnums";
import * as moment from "moment";

@Component({
    selector: "app-events",
    templateUrl: "./events.component.html",
    styleUrls: [
        "./events.component.css",
        "../shared/common/styles/congress.css",
    ],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
})
export class EventsComponent extends AppComponentBase implements OnInit {
    @ViewChild("eventInformationsModal")
    eventInformationsModal: EventInformationsModalComponent;
    @ViewChild("content") content: ElementRef;

    currentDate = moment(moment().format("YYYY-MM-DD"));
    saving = false;
    loaded = false;

    paramType: string;

    //Filters
    filterText = "";
    filterEventType = undefined;
    filterEvents = [];
    filterShowRelatedEvents = undefined;

    userId = undefined;
    settings: TerminalSettingDto = undefined;
    cart = undefined;
    userToRegistration = undefined;

    events = [];
    types = [];
    subscriptions = [];
    cartItems = [];
    cartItemsIds = [];

    onLocal = false;
    orderId = 0;
    success = false;
    filterTypeParam: string = undefined;

    //Registration props
    appUserAddressDtoType = AppUserAddressDtoType;

    constructor(
        injector: Injector,
        private activatedRoute: ActivatedRoute,
        private _eventsService: EventsServiceProxy,
        private _eventTypesService: EventTypesServiceProxy,
        private _cartHelperService: CartHelperService,
        private _paymentChargesService: PaymentChargesServiceProxy,
        private _ordersService: OrdersServiceProxy,
        private _terminalSettingsService: TerminalSettingsService,
        private _registrationsService: RegistrationsServiceProxy,
        private _router: Router
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.onLocal = params["onLocal"] == "true";
            this.paramType = params["type"];
        });

        this.showRegistrationMessage();
        this.registerToEvents();
        this.loadUserForSubscription();
        this.checkBag();
        this.getEvents();
    }

    showRegistrationMessage() {
        if (localStorage.getItem("showRegistrationMessage")) {
            this.notify.error(
                "Caso efetue a inscrição na categoria incorreta, o departamento de eventos entrará em contato para regularização: acerto do valor e/ou cobrança de documentação. O certificado de participação somente será disponibilizado aos participantes com inscrição regularizada",
                "Atenção",
                {
                    timeOut: 30000,
                    closeButton: true,
                    onclick: (e) => {
                        localStorage.removeItem("showRegistrationMessage");
                    },
                    onCloseClick: (e) => {
                        localStorage.removeItem("showRegistrationMessage");
                    },
                }
            );
        }
    }

    registerToEvents() {
        abp.event.on("app.cart.refresh", () => {
            this.checkAllBagItems();
        });
    }

    //Get events and courses
    getEvents() {
        this.settings = this._terminalSettingsService.getSettings();

        if (this.settings) {
            this.filterEvents = this.settings.eventsList.map(
                (x) => x.id
            ) as Array<number>;
            this.filterShowRelatedEvents = this.settings.showRelatedEvents;
        }

        this.block(".events-content");
        this.loading = true;
        this._eventsService
            .getEventsForSignUp(
                this.filterText,
                undefined,
                undefined,
                this.filterEventType
                    ? this.filterEventType
                    : this.filterTypeParam,
                this.userId,
                this.onLocal,
                true, //categorias local
                undefined,
                undefined,
                this.filterEvents,
                this.filterShowRelatedEvents
            )
            .finally(() => {
                this.unBlock(".events-content");
            })
            .subscribe((result) => {
                this.subscriptions = result.items;
                this.checkAllBagItems();

                if (this.types.length == 0) {
                    this.types = result.eventTypes;
                } else {
                    this.checkEventTypes(result.eventTypes);
                }

                if (this.paramType) {
                    this.filterEventType = this.paramType;
                    this.getEvents();
                    this.paramType = undefined;
                } else {
                    this.loaded = true;
                    localStorage.setItem(
                        "event-types",
                        JSON.stringify(this.types)
                    );
                }
            });
    }

    // Add news items to the Type List
    checkEventTypes(eventTypes: string[]) {
        eventTypes.forEach((x) => {
            if (_.filter(this.types, (t) => t == x).length == 0) {
                this.types.push(x);
            }
        });
    }

    checkFilterParam(type: string) {
        return (
            this.filterTypeParam &&
            this.filterTypeParam.toLocaleLowerCase() == type.toLocaleLowerCase()
        );
    }

    clear(): void {
        this.filterText = "";
        this.filterEventType = undefined;
    }

    // Get Types
    filterTypes(event): void {
        this._eventTypesService
            .getEventTypesForSelect(event.query)
            .subscribe((result) => {
                this.types = result.items;
            });
    }

    /// Picture
    getEventPicture(eventPictureId: string): string {
        ///assets/common/images/user_profile_bg.png
        let eventPicture = "/assets/common/images/default-profile-picture.png";

        if (eventPictureId) {
            this._eventsService
                .getEventImageById(eventPictureId)
                .subscribe((result) => {
                    if (result && result.eventImage) {
                        eventPicture =
                            "data:image/jpeg;base64," + result.eventImage;
                    }

                    return eventPicture;
                });
        } else {
            return eventPicture;
        }
    }

    //Load user for subscription
    loadUserForSubscription(): void {
        this.saving = true;
        this._registrationsService
            .getUserForRegistration(
                this.appSession.userId,
                undefined,
                undefined
            )
            .subscribe((result) => {
                this.userToRegistration = result;
                this._cartHelperService.updateUserCart(
                    this.userToRegistration,
                    false
                );
                this.cart = this._cartHelperService.getCart(this.onLocal);
                abp.event.trigger("app.cart.refresh");
            });
    }

    resetToBag(
        event: EventToSignUpDto,
        selectedCategory: EventCategoryDeadlineDto
    ) {
        let inBag = this.cartItems.filter(
            (x) => x.registration.eventId == event.id
        );
        if (inBag) {
            this.removeFromBag(event.id);
            this.addToBag(event, selectedCategory);
        }
    }

    //Add item to bag
    addToBag(
        event: EventToSignUpDto,
        selectedCategory: EventCategoryDeadlineDto
    ): void {
        this.saving = true;

        if (!this.cart.user) {
            this.loadUserForSubscription();
        }

        //load Registration
        let registration = new CreateOrEditRegistrationByAdminDto();
        registration.eventId = event.id;
        registration.user = new RegistrationUserEditDto();
        registration.user.id = this.cart.user.id;
        registration.user.name = this.cart.user.name;
        registration.user.nameForCredential = this.cart.user.nameForCredential;
        registration.user.userName = this.cart.user.userName;
        registration.user.emailAddress = this.cart.user.emailAddress;
        registration.user.address = this.cart.user.address;
        registration.user.emails = this.cart.user.emails;
        registration.user.phones = this.cart.user.phones;
        let note: NoteDto = new NoteDto();
        note.description = this.settings.name;
        let messageRegistration: CreateOrEditRegistrationOutput = undefined;
        let couponPaymentMethodPermission = event.paymentMethods.filter(
            (x) => x.paymentMethod.paymentMethodType == PaymentMethod.Coupon
        )[0];

        let categoryDeadline: EventCategoryDeadlineDto = undefined;
        if (this.userToRegistration) {
            categoryDeadline = selectedCategory;
        }

        if (!categoryDeadline) {
            categoryDeadline = event.categoryDeadlines.filter(
                (x) =>
                    x.description.indexOf(
                        this.userToRegistration.categoryName
                    ) != -1
            )[0];

            if (!categoryDeadline) {
                categoryDeadline = event.categoryDeadlines.filter(
                    (x) => x.value > 0
                )[0];
            }
        }

        //load Patyment
        let payment = new PaymentDto();
        payment.paidDate = moment().startOf("day");
        payment.totalPaid = 0;
        payment.appliedDiscount = 0;

        payment.totalPaid = this.calculateTotalPaid(payment, categoryDeadline);

        if (
            payment.totalPaid == 0 &&
            registration.coupon &&
            registration.coupon.discountAmount >= payment.totalPaid
        ) {
            registration.paymentMethodId = couponPaymentMethodPermission.id;
        }

        registration.payments = [];
        registration.payments.push(payment);

        let eventItem = new RegistrationEventDto();
        eventItem.name = event.name;
        eventItem.eventImage = event.eventImage;
        eventItem.beginDate = event.beginDate;
        eventItem.endDate = event.endDate;
        eventItem.place = event.place;

        let item: IRegistrationCart = {
            registration: registration,
            categoryDeadline: categoryDeadline,
            event: eventItem,
        };

        if (categoryDeadline) {
            this._cartHelperService.addRegistrationToCart(item, false);

            abp.event.trigger("app.cart.refresh");
            this.cart = this._cartHelperService.getCart(this.onLocal);

            this.checkAllBagItems();
        }
    }

    //Remove item from bag
    removeFromBag(item: number) {
        this._cartHelperService.removeRegistrationByEventId(item);

        abp.event.trigger("app.cart.refresh");
        this._cartHelperService.updateUserCart(this.userToRegistration, false);
        this.cart = this._cartHelperService.getCart(this.onLocal);

        this.checkAllBagItems();
    }

    //Check bag finish transaction
    checkBag(): void {
        if (this.orderId > 0) {
            if (this.success) {
                let input = new EntityDtoOfInt64();
                input.id = this.orderId;

                this._paymentChargesService
                    .finishPayment(input)
                    .subscribe(() => {
                        this._cartHelperService.finalizeCart();

                        this.message.success(
                            this.l("Order successfully registered.")
                        );
                        this._ordersService
                            .sendConfirmPaymentEmail(input)
                            .subscribe((result) => {});
                        this._router.navigate(["app/event/signUp"]);
                    });
            } else {
                this._cartHelperService.finalizeCart();
                this.message.warn(this.l("Denied Transaction."));
                this._router.navigate(["app/financial/payment"], {
                    queryParams: {
                        receivableId: this.orderId,
                    },
                });
            }
        }
    }

    checkAllBagItems() {
        this.cart = this._cartHelperService.getCart(this.onLocal);

        if (this.cart && this.cart.registrations) {
            this.cartItems = this.cart.registrations;

            this.subscriptions.forEach((s) => {
                s.event.inBag =
                    this.cartItems.filter(
                        (x) => x.registration.eventId == s.event.id
                    ).length > 0;

                var self = this;

                if (s.event.inBag && !s.categoryDeadline) {
                    let cartCategory = self.cartItems.filter(
                        (x) => x.registration.eventId == s.event.id
                    )[0].categoryDeadline;

                    s.categoryDeadline = s.event.categoryDeadlines
                        ? s.event.categoryDeadlines.filter((x) => x.id ==  cartCategory.id)[0]
                        : undefined;
                }
            });
        }
    }

    //Check bag item
    checkBagItems(eventId: number): boolean {
        if (this.cart && this.cart.registrations) {
            this.cartItems = this.cart.registrations;
            return (
                this.cartItems.filter((x) => x.registration.eventId == eventId)
                    .length > 0
            );
        }
    }

    //Calculate values
    calculateValue(
        registration: any,
        payment: any,
        categoryDeadline: any,
        paymentMethodSelected: any,
        messageRegistration: any
    ): void {
        let input = new UpdatePaymentInput();
        input.payment = payment;

        input.coupon = registration.coupon;
        input.categoryDeadLine = categoryDeadline;
        input.paymentMethodPermissionId = paymentMethodSelected.id;

        input.payment.appliedDiscount = input.payment.appliedDiscount
            ? input.payment.appliedDiscount
            : 0;
        registration.categoryDeadlineId = categoryDeadline.id;

        this._registrationsService
            .updateRegistrationPaymentValuesAsync(input)
            .subscribe((result) => {
                payment = result;

                if (registration.user.id) {
                    this._registrationsService
                        .checkExistingRegistration(registration)
                        .subscribe((result) => {
                            messageRegistration = result;
                        });
                }
            });
    }

    // Calculate Total Paid
    calculateTotalPaid(payment: PaymentDto, categoryDeadline: any): number {
        if (!categoryDeadline)
            this.message.error(
                "Verifique se existem categorias com inscrição no local para este evento e se sua categoria está habilitada para participar.",
                "Categoria não encontrada!"
            );
        else {
            payment.totalPaid =
                categoryDeadline.value - payment.appliedDiscount;
        }

        return payment.totalPaid;
    }
}



// WEBPACK FOOTER //
// ./src/congress/events/events.component.ts